const state = {
  isShow: false,
  loading: false,
  items: [],
  isOkNum: 0,
  isBadNum: 0,
  greaterThan30:false
};

const mutations = {

};

const actions = {

};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};




// WEBPACK FOOTER //
// ./src/store/badLink.js